module.exports = __webpack_public_path__ + "img/lite-panoramic.8eacc352.jpg";